import React from "react"

const Recipe = ({title, calories, image, url, portions, ingredients}) => {
    return (
        <div className='recipe'>
            <img src={image} alt={title} className='recipe-image'/>
            <div className="recipe-info">
                <h1 className='recipe-title'>{title}</h1>
                <p className='recipe-calories'>Calories: {calories}</p>
                <ul className='ingredients'>
                    <p>Ingredients for {portions} portions:</p>
                    {ingredients.map(ingredient => (
                        <li className='ingredient' key={`${ingredient.weight + ingredients.indexOf(ingredient) + Math.random() * 5}`}>{ingredient.text}</li>
                    ))} 
                </ul>
                <a href={url} target="_blank" className='recipe-link'>Full recipe &#10138;</a>
            </div>
        </div>
    )
}

export default Recipe